import { SharepointItem } from '../sharepoint-item.interface';

export interface EquipmentProductFileFound {
  givenListOfIds: string[];
  itemsFound: SharepointItem[];
  itemsNotFound: string[];
}
